export default {
	meta: {
		title: 'Import des fichiers',
		description: 'Import des fichiers'
	},
	supportBtn: 'Centre d\'aide',
	supportBtnTitle: 'Redirige vers un site extérieur de documentation'
};
